import { useEffect, useRef, useState } from "react";

export function useToast(durationMs = 2500) {
  const [message, setMessage] = useState("");
  const timerRef = useRef(null);

  function show(msg) {
    setMessage(msg);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setMessage(""), durationMs);
  }

  function clear() {
    setMessage("");
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = null;
  }

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return { message, show, clear };
}
